import {RouterProps} from "../../../RouterProps";
import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";

export default function UsageRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:assetCouponUsageId'} element={<Detail {...props} />} />
        </Routes>
    </>
}